export const AUTH_MIN_HEIGHT = 582;
export const FAST_CHECKOUT_MIN_HEIGHT = 545;
export const AUTH_MIN_WIDTH = { xs: 'calc(100vw - 20px)', sm: 'auto' };
